import SELECT_NEWSROOM from './actionTypes';

export default function reducer(state = '', { type, newsroom }) {
    if (type === SELECT_NEWSROOM) {
        return newsroom;
    }

    return state;
}
